import SyllabusService from "../../services/Syllabus";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const QUERY_KEY = "syllabi";

function useListSyllabi() {
  return useAuthorizedQuery(QUERY_KEY, () => SyllabusService.listSyllabi());
}

export default useListSyllabi;
